export default __webpack_public_path__ + "static/media/Group 3419@2x.fc072cac.png";